<template lang="pug">
.face_box
  .logo_box(v-if="data.logo")
    img.logo_img(:src="data.logo")

  h2.questions_title {{ localizedName }}

  .svg_box
    .svg_item(v-for="(item, index) in svgDate" :key="index")
      .svg
        svg-icon(
          v-if="highlighted !== index"
          :icon-class="item.name"
          @click="submit(index)"
        )
        svg-icon(v-else :icon-class="item.bright")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedCampaignField } from '@/utils/language'

@Component({
  props: {
    index: Number,
    data: Object
  },
  computed: {
    localizedName() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.data, 'displayName') || getLocalizedCampaignField(this.data, 'name') || this.data?.name || ''
    }
  }
})

class faceComponents extends Vue {
  highlighted = null
  svgDate = [
    {
      name: 'Face-05-Unselected',
      bright: 'Face-05-Selected',
    },
    {
      name: 'Face-04-Unselected',
      bright: 'Face-04-Selected',
    },
    {
      name: 'Face-03-Unselected',
      bright: 'Face-03-Selected',
    },
    {
      name: 'Face-02-Unselected',
      bright: 'Face-02-Selected',
    },
    {
      name: 'Face-01-Unselected',
      bright: 'Face-01-Selected',
    },
  ]

  submit(index) {
    const number = this.svgDate.length - index // Returns the index of SVG image flashback   // 返回 SVG 图片倒叙的索引
    // Face-01 最开心 … Face-05 最不开心。转成"开心度"(5=最开心)再与 minScore 比,与 svgDate 渲染顺序无关;answer 仍用 number
    const survey = this.data?.settings?.survey
    const minScore = survey?.minScore
    const reviewCampaign = survey?.reviewCampaign
    const faceItem = this.svgDate[index]
    const faceLevel = Number(String(faceItem?.bright || faceItem?.name || '').match(/Face-0?(\d+)/)?.[1]) || 0
    const happiness = faceLevel ? (this.svgDate.length + 1) - faceLevel : 0
    const campaign = (minScore && reviewCampaign && happiness >= minScore) ? reviewCampaign : false
    this.$emit('event', number, campaign) // Expose click events   // 暴露点击事件
    this.highlighted = index
  }

  _initializationData() {
    this.highlighted = null
  }
}

export default faceComponents
</script>

<style lang="sass" scoped>
@use "../style/index" as *

.face_box
  .questions_title
    font-weight: bold

  .svg_box
    display: flex
    justify-content: center
    flex-wrap: wrap

    .svg_item
      &:nth-of-type(2)
        margin-right: 25px
        margin-left: 23px

      &:nth-of-type(4)
        margin-right: 24px

    .svg
      margin-bottom: 13px

.svg
  width: 85px
  height: 85px
</style>
